import config from 'src/config/i18n.json';
import deepClone from 'src/utils/deep_clone';

export const languagesRegExp = `(${config.languageKeys.join('|')})`;

export function languageDirection(language: string): string {
	return config.languages[language].direction;
}

export function isDefaultLanguage(language: string): boolean {
	return config.defaultLanguage === language;
}

export function stripUrlLanguage(url: string): string {
	return url.replace(new RegExp(`^/${languagesRegExp}/`), '/').replace(new RegExp(`^/${languagesRegExp}$`), '/');
}

export function processLanguageResources(resources) {
	const output = deepClone(resources);

	delete output.__import_depth;

	Object.keys(output).forEach((langKey) => {
		delete output[langKey].__import_depth;

		Object.keys(output[langKey]).forEach((groupKey) => {
			delete output[langKey][groupKey].__import_depth;

			Object.keys(output[langKey][groupKey]).forEach((resourceKey) => {
				if (output[langKey][groupKey][resourceKey].__import_depth === 3) {
					delete output[langKey][groupKey][resourceKey].__import_depth;

					Object.keys(output[langKey][groupKey][resourceKey]).forEach((miniResourceKey) => {
						delete output[langKey][groupKey][resourceKey][miniResourceKey].__import_depth;

						output[langKey][`${groupKey}.${resourceKey}.${miniResourceKey}`] =
							output[langKey][groupKey][resourceKey][miniResourceKey];
					});
				} else {
					output[langKey][`${groupKey}.${resourceKey}`] = output[langKey][groupKey][resourceKey];
				}
			});

			// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
			delete output[langKey][groupKey];
		});
	});

	return output;
}
